var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.445 6.869A6.673 6.673 0 017.11.203a6.674 6.674 0 016.666 6.666.667.667 0 01-1.334 0c0-2.94-2.392-5.332-5.332-5.332S1.778 3.928 1.778 6.869a.667.667 0 01-1.333 0zM13.53 8.554H.69a.667.667 0 100 1.333h12.841a.667.667 0 100-1.333zm-1.588 4.11H2.278a.666.666 0 100 1.334h9.665a.667.667 0 000-1.334z",
    fill: "#647A97",
    fillRule: "nonzero"
  })));
}
export default SvgSunset;